import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";

export const ConversationLoadingSkeleton = () => (
  <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
    <div className="mx-auto flex w-full max-w-2xl flex-col gap-4 px-5 py-4">
      <Row full />
      <Row full />
      <Row full />
      <Row full />
      <Row full />
    </div>
  </div>
);
